import { UptimeLoadingWithBackdrop } from '@uptime/uptime-component';
import LoadingScreen from 'components/LoadingScreen';
import React from 'react';
import { useTheme } from 'styled-components';

interface LoadingScreenWithBackdropProps {
  isOpen: boolean;
  loadingText?: string;
}

const LoadingScreenWithBackdrop = ({ isOpen, loadingText }: LoadingScreenWithBackdropProps) => {
  const theme = useTheme();
  return (
    <UptimeLoadingWithBackdrop
      isOpen={isOpen}
      stylewrapper={{ textColor: theme.uptimeColors.grayScales.black }}
    >
      <LoadingScreen caption={loadingText} />
    </UptimeLoadingWithBackdrop>
  );
};

export default LoadingScreenWithBackdrop;
